import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal }                     from '@ng-bootstrap/ng-bootstrap';
import { UIRouter }                     from '@uirouter/core';
import { Subscription }                 from 'rxjs';

import { CodeTypeModel }            from '../core/models/code-type';
import { CompanyMessagesModel }     from '../companies/models/company.messages';
import { CompanyService }           from '../companies/company.service';
import { JobsService }              from './jobs/transaction-center.jobs.service';
import { SendJobBulkSmsComponent }  from './jobs/transaction-center.jobs.send-bulk-sms.component';
import { TransactionCenterService } from './transaction-center.service';

@Component({
  selector   : 'wor-transaction-center',
  template: require('./transaction-center.component.html')
})
export class TransactionCenterComponent implements OnDestroy, OnInit {
  filters = {
    value: ''
  };

  searchSubscription: Subscription;

  constructor (
    public  companyService          : CompanyService,
    private jobsService             : JobsService,
    private modalService            : NgbModal,
    private router                  : UIRouter,
    private transactionCenterService: TransactionCenterService
  ) {}

  ngOnDestroy () : void {
    this.searchSubscription?.unsubscribe();
  }

  ngOnInit () : void {
    this.searchSubscription = this.transactionCenterService.searchChanges
      .subscribe(value => {
        if ( value !== null ) {
          this.filters.value = value;
        }
      });
  }

  createNew () : void {
    const tab = (this.router.globals.current.name || '')
      .replace('app.transaction-center.', '');

    const states = {
      bookings         : 'app.event',
      inspections      : 'app.inspection',
      jobs             : 'app.invoice',
      orders           : 'app.purchase-order',
      'vendor-invoices': 'app.vendor-invoice'
    };

    if ( states[ tab ] ) {
      this.router.stateService.go(states[ tab ]);
    }
  }

  filter () : void {
    this.transactionCenterService.setSearch(this.filters.value);
  }

  isTab ( tab : string ) : boolean {
    return this.router.stateService.is(`app.transaction-center.${ tab }`);
  }

  printJobsForDate () : Promise<any> {
    return this.jobsService.printForDate();
  }

  sendBulkSMS () : Promise<any> {
    return Promise.all([
      this.jobsService.getConstraints(),
      this.jobsService.getStatusOptions(),
      this.companyService.getDefaultMessages()
    ])
    .then(( [
        constraints,
        statusTypes,
        messageSettings
      ] : [
        Array<CodeTypeModel>,
        Array<CodeTypeModel>,
        CompanyMessagesModel
      ] ) => {
      const modal = this.modalService.open(SendJobBulkSmsComponent, {
        windowClass: 'lg-modal flip-container'
      });

      modal.componentInstance.constraints     = constraints;
      modal.componentInstance.statusTypes     = statusTypes;
      modal.componentInstance.messageSettings = messageSettings;

      return modal.result;
    });
  }
}
